import request from 'next/javascripts/modules/request';

const renderCards = {
  default(item) {
    let template = '';

    if (typeof item === 'string') {
      template = item;
    } else {
      template = `
        <a class="card-link" href="${item.url}" target="_blank">
          <span class="card-icon-wrapper">
            <img class="card-icon" src="${process.env.OSS_ASSETS_ENDPOINT}/resource_cards/${item.type}.svg" />
            <span class="card-type">${item.typeName}</span>
          </span>
          <span class="card-content">
            <span class="card-title">${item.name}</span>
          </span>
        </a>`;
    }
    return template;
  },
};

export default class CardRenderer {
  constructor({ type, item, editing }) {
    this.type = type;
    this.item = item;
    this.editing = editing;
  }

  async render() {
    const renderMethod = renderCards[this.type] || renderCards.default;
    let result = renderMethod.call(this, await this.fetchItem());

    if (this.editing) result += '<div class="editing-mask"></div>';
    return result;
  }

  abort() {
    if (this.requestXHR) this.requestXHR.abort();
  }

  fetchItem() {
    return new Promise((resolve) => {
      const url = window.tower ? window.tower.resource_card_path : '';

      if (url) {
        this.abort();
        this.requestXHR = request({
          url: `${url}?team_wide_id=${this.item.id.replace(/\D/g, '')}`,
          dataType: 'html',
          error: () => resolve(this.item),
        }, ({ content }) => resolve(content));
      } else {
        resolve(this.item);
      }
    });
  }
}
